<template>
  <div class="accountdetail">
    <van-nav-bar
        title="用气详情"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="margin0"/>

    <van-cell v-model="C_Code" icon="user-circle-o" size="large" >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{C_Name}}</span>
      </template>
    </van-cell>
    <van-cell  icon="wap-home-o">
      <template #title>
        <span class="custom-title2">{{C_Address}}</span>
      </template>
    </van-cell>

    <div class="margin1"/>

    <van-cell-group >
      <van-cell  v-model="AD_WriteTime" icon="calendar-o" size="large">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span class="custom-title">挂账日期  </span>
          <van-tag v-if="AD_Flag === '销账'" type="success">{{AD_Flag}}</van-tag>
          <van-tag v-if="AD_Flag === '欠费'" type="danger">{{AD_Flag}}</van-tag>
          <van-tag v-if="AD_Flag === '扣费途中'" type="warning">{{AD_Flag}}</van-tag>
          <van-tag v-if="AD_Flag === '微信扣费中'" type="warning">{{AD_Flag}}</van-tag>
        </template>
      </van-cell>
      <van-cell title="收费类型" v-model="AD_Class" icon="bar-chart-o"/>
      <van-cell title="收费金额" v-model="AD_Money" icon="gold-coin-o"/>
      <van-divider>缴费详情</van-divider>
      <van-cell title="缴费日期" v-model="AD_Date"/>
      <van-cell title="缴费方式" v-model="AD_PayMode"/>
    </van-cell-group>

    <div style="margin: 16px;">
      <van-button v-if="AD_Flag === '销账'" disabled = "false" round block type="primary" > 已销账 </van-button>
      <van-button v-if="AD_Flag === '扣费途中'" disabled = "false" round block type="primary" >暂时无法缴费</van-button>
      <van-button v-if="AD_Flag === '微信扣费中'" round block type="info" @click="checkOrder">去缴费</van-button>
      <van-button v-if="AD_Flag === '欠费'" round block type="info" @click="checkOrder">去缴费</van-button>
    </div>

<!--    <van-button round block type="info" @click="payADSus">测试</van-button>-->


  </div>
</template>
<script>
import { Toast } from 'vant';
import API from './../api/index';
export default {
  name: 'page_accountdetail',
  data() {
    return {
      C_ID:"",
      C_Code:"",
      C_Name:"",
      C_Address:"",
      list: [],
      AD_WriteTime:"",
      AD_Class:"",
      AD_Money:"",
      AD_Flag:"",
      AD_Date:"",
      AD_PayMode:"",
      AD_ID:"",
      WP_ID:""
    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },
    setMessage() {
      this.C_ID=this.$cookie.get('CID');
      this.C_Code=this.$cookie.get('C_Code');
      this.C_Address=this.$cookie.get('CAddress');
      this.C_Name=this.$cookie.get('CName');
      this.AD_ID =this.$cookie.get('AD_ID');
      this.$http.get(API.SearchAccountDetail,{
        params: {
          AD_ID:this.AD_ID
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.AD_ID=res.AD_ID;
              this.AD_Flag=res.AD_Flag;
              this.AD_Money=res.AD_Money;
              this.AD_Class=res.AD_Class;
              this.AD_Date=res.AD_Date;
              this.AD_PayMode=res.AD_PayMode;
              this.AD_WriteTime=res.AD_WriteTime;
            }
          });
    },
    checkOrder() {
      Toast.loading({
        message: '请稍候...',
        forbidClick: true,
        duration: 0 ,
      });
      this.$http.get(API.CheckAccountDetail,{
        params: {
          AD_ID:this.AD_ID,
          AD_Money:this.AD_Money
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.order();
            } else {
              Toast.clear();
              Toast('费用产生变化，请刷新重试');
              this.$router.go(0);
            }
          });

    },
    order() {
      this.$http.get(API.AccountDetailOrder,{
        params: {
          c_id:this.C_ID,
          ad_id:this.AD_ID,
          ad_pay:this.AD_Money
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.WP_ID = res.message;
              this.searchOrder();
              //Toast(res.message)
            } else {
              Toast.clear();
            }
          });

    },
    searchOrder() {
      let _this=this
      setTimeout(function () {
        _this.searchOrderFunction();
      },500)

    },
    searchOrderFunction() {
      this.$http.get(API.searchOrder,{
        params: {
          WP_ID:this.WP_ID
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              if (res.WP_Flag == 1) {
                console.log('准备调用微信支付1.2')
                this.searchOrder();
              } else if (res.WP_Flag == 3) {
                console.log('准备调用微信支付1.1')
                //Toast('准备调用微信支付1.1');
                this.orderPay(res);
              } else if (res.WP_Flag == 0) {

                console.log('准备调用微信支付1.3')
                this.searchOrder();
              } else {
                console.log('准备调用微信支付1.4')
                Toast.clear();
                Toast('下单失败，请稍候重试')
              }

            } else {
              console.log('准备调用微信支付1.5')
              Toast.clear();
              Toast('下单失败，请稍候重试')
            }
          });
    },
    orderPay(res) {
      console.log('准备调用微信支付2')
      //Toast('准备调用微信支付2')
      let vm = this
      if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
        console.log('准备调用微信支付3.1')
        //Toast()
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(res), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(res))
          document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(res))
        }
      } else {
        console.log('准备调用微信支付3.2')
        vm.onBridgeReady(res)
      }
    },
    onBridgeReady (data) {
      console.log('调用微信支付WeixinJSBridge')
      //Toast('调用微信支付WeixinJSBridge')
      let vm = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.WP_appId, // 公众号名称，由商户传入
            'timeStamp': data.WP_timeStamp, // 时间戳
            'nonceStr': data.WP_nonceStr, // 随机串
            'package': data.WP_package, // 预支付id
            'signType': data.WP_signType, // 微信签名方式
            'paySign': data.WP_paySign // 微信签名
          },
          function (res) {
            //Toast(res.err_msg);
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {

              vm.$http.get(API.PayADSus,{
                params: {
                  WP_ID:vm.WP_ID
                }
              })
                  .then((response)=>{
                    let res = response.data;
                    if (res.code === 0) {
                      Toast.clear();
                      Toast('支付成功');
                      vm.$router.push('/ybsf')
                    } else {
                      Toast.clear();
                      Toast('支付成功');
                      vm.$router.push('/ybsf')
                    }
                  });

            } else {
              //Toast(res.err_msg);
              vm.$http.get(API.PayADFail,{
                params: {
                  WP_ID:vm.WP_ID
                }
              })
                  .then((response)=>{
                    let res = response.data;
                    if (res.code === 0) {
                      Toast.clear();
                      Toast('支付失败，请稍候重试');
                      vm.$router.push('/ybsf')
                    } else {
                      Toast.clear();
                      Toast('支付失败，请稍候重试');
                      vm.$router.push('/ybsf')
                    }
                  });
            }
          }
      )
    },
    payADSus () {
      this.$http.get(API.PayADSus,{
        params: {
          WP_ID:this.WP_ID
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              Toast.clear();
              Toast('支付成功');
              this.$router.push('/ybsf')
            } else {
              Toast.clear();
              Toast('支付成功');
              this.$router.push('/ybsf')
            }
          });
    },
    payADFail() {

    },

  },
  mounted () {
    this.setMessage();
  },
  destroyed() {
    Toast.clear();
  },
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.margin1{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.margin0{
  height: 0.5rem;
  background-color: #f5f5f5;
}

</style>